import clsx from "clsx";
import { FC, ReactNode } from "react";

interface Props {
  className?: string;
  children: ReactNode;
}

const Box: FC<Props> = ({ children, className }) => {
  return (
    <div className={clsx(className, "shadow p-3 md:p-5 bg-white rounded-lg")}>
      {children}
    </div>
  );
};

export default Box;
